module.exports = __webpack_public_path__ + "static/media/default-company-logo-white.97bd91f2.png";